import {
    AssessmentType,
    ExternalAssessmentStates
} from '../constants-types/Enums';

export class CognitiveJobAssessment {
    jobId: string;
    assessmentState?: ExternalAssessmentStates;
    completedDate: Date;
    expirationDate?: Date;
    id?: string;
    sentDate: Date;
    type?: AssessmentType = AssessmentType.Job;
    // This isn't a Person
    recipientName: string;
    recipientEmail: string;

    cognitiveJobScore: number;
    cognitiveJobScale: number;
    cognitiveJobPercentileRank: number;
    cogJASkillResponses: number[];

    constructor(obj?: any) {
        Object.assign(this, obj);
    }

    isPending(): boolean {
        return this.assessmentState === ExternalAssessmentStates.Pending;
    }

    isExpired(): boolean {
        return this.assessmentState === ExternalAssessmentStates.Expired;
    }

    isPendingOrExpired(): boolean {
        return this.isPending() || this.isExpired();
    }
}
